/**
 * Shared flag: is a Phaser card drag currently in flight?
 *
 * Written by DragDropManager on dragstart/dragend; read by the `v-overlay-barrier`
 * directive. While a drag is active the barrier must NOT stop the pointer events
 * that terminate the drag (pointerup/mouseup/touchend) — otherwise the release
 * over a board-overlapping HUD widget never reaches Phaser's window listener,
 * Phaser never fires drop/dragend, and the dragged card is stranded on the
 * cursor. With no drag in flight the barrier blocks as normal so taps don't leak
 * to the board. See "Overlay Event Isolation" in app/frontend/game/CLAUDE.md.
 */
let _active = false;

export function setPhaserDragActive(value) {
  _active = !!value;
}

export function isPhaserDragActive() {
  return _active;
}
